module.exports = __webpack_public_path__ + "img/paint_down_code.9e407378.png";